import { createFileRoute } from '@tanstack/react-router'

import PublicProjects from 'pages/PublicProjects'

export const Route = createFileRoute('/public/projects/')({
  component: PublicProjects,
})
